import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "hueStyle", "hueHeight", "hueMargin", "hueWidth", "defaultColor", "value", "saturationHeight", "saturationWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import HueSpectrum from './HueSpectrum';
import SaturationSpectrum from './SaturationSpectrum';
import toColorValue from './utils/toColorValue';
import toStringValue from './utils/toStringValue';
import DEFAULT_COLOR from './defaultColor';

var ColorPicker = /*#__PURE__*/function (_Component) {
  _inherits(ColorPicker, _Component);

  var _super = _createSuper(ColorPicker);

  // eslint-disable-next-line react/static-property-placement
  // eslint-disable-next-line react/static-property-placement
  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSaturationChange", function (color) {
      _this.handleChange(color);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHueChange", function (color) {
      _this.handleChange(color);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHueDrag", function (hsv) {
      _this.setState({
        dragHue: hsv.h
      });

      _this.handleDrag(hsv);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaturationDrag", function (hsv) {
      _this.handleDrag(hsv);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHueMouseDown", function (hsv) {
      _this.setState({
        dragHue: hsv.h
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaturationMouseDown", function (hsv) {
      _this.setState({
        dragHue: hsv.h
      });
    });

    _this.state = {
      dragHue: null
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: "handleDrag",
    value: function handleDrag(color) {
      var onDrag = this.props.onDrag;
      onDrag(toStringValue(color), color);
    }
  }, {
    key: "handleChange",
    value: function handleChange(color) {
      var onChange = this.props.onChange;
      this.setState({
        dragHue: null
      });

      var newColor = _objectSpread({}, color);

      var value = toStringValue(newColor);
      onChange(value, newColor);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var propsClassName = props.className,
          propsHueStyle = props.hueStyle,
          hueHeight = props.hueHeight,
          hueMargin = props.hueMargin,
          hueWidth = props.hueWidth,
          defaultColor = props.defaultColor,
          propsValue = props.value,
          saturationHeight = props.saturationHeight,
          saturationWidth = props.saturationWidth,
          divProps = _objectWithoutProperties(props, _excluded);

      var dragHue = this.state.dragHue;
      var className = cx(propsClassName, 'cp react-color-picker');

      var hueStyle = _objectSpread(_objectSpread({}, propsHueStyle), {}, {
        marginLeft: hueMargin
      });

      var value = toColorValue(propsValue || defaultColor);
      var children = props.children;
      var hueSpectrumProps = null;
      var saturationSpectrumProps = null;

      if (children) {
        children = React.Children.toArray(children).forEach(function (child) {
          if (child && child.props) {
            if (child.props.isHueSpectrum) {
              hueSpectrumProps = _objectSpread({}, child.props);
            }

            if (child.props.isSaturationSpectrum) {
              saturationSpectrumProps = _objectSpread({}, child.props);
            }
          }
        });
      }

      var saturationConfig = _objectSpread({
        onDrag: this.handleSaturationDrag,
        onChange: this.handleSaturationChange,
        onMouseDown: this.handleSaturationMouseDown
      }, saturationSpectrumProps);

      if (saturationConfig.width === undefined) {
        saturationConfig.width = saturationWidth;
      }

      if (saturationConfig.height === undefined) {
        saturationConfig.height = saturationHeight;
      }

      saturationConfig.inPicker = true;

      var hueConfig = _objectSpread({
        onDrag: this.handleHueDrag,
        onChange: this.handleHueChange,
        onMouseDown: this.handleHueMouseDown,
        style: hueStyle
      }, hueSpectrumProps);

      if (hueConfig.width === undefined) {
        hueConfig.width = hueWidth;
      }

      if (hueConfig.height === undefined) {
        hueConfig.height = hueHeight || saturationHeight;
      }

      hueConfig.inPicker = true;

      if (dragHue) {
        value.h = dragHue;
      }

      saturationConfig.value = _objectSpread({}, value);
      hueConfig.value = _objectSpread({}, value);
      return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
        className: className
      }), /*#__PURE__*/React.createElement(SaturationSpectrum, saturationConfig), /*#__PURE__*/React.createElement(HueSpectrum, hueConfig));
    }
  }]);

  return ColorPicker;
}(Component);

_defineProperty(ColorPicker, "propTypes", {
  className: PropTypes.string,
  hueStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onDrag: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.any,
  defaultColor: PropTypes.any,
  hueHeight: PropTypes.number,
  hueMargin: PropTypes.number,
  hueWidth: PropTypes.number,
  saturationWidth: PropTypes.number,
  saturationHeight: PropTypes.number,
  children: PropTypes.node
});

_defineProperty(ColorPicker, "defaultProps", {
  className: '',
  hueStyle: {},
  onDrag: Function.prototype,
  onChange: Function.prototype,
  value: null,
  defaultColor: DEFAULT_COLOR,
  hueHeight: null,
  hueMargin: 10,
  hueWidth: 30,
  saturationWidth: 300,
  saturationHeight: 300,
  children: null
});

export { HueSpectrum, SaturationSpectrum };
export default ColorPicker;